/**
 * Z-Index layering system for overlays and dialogs
 *
 * Layer hierarchy:
 * - Base: Normal content (0-49)
 * - Overlays: Base dialogs and sheets (999-1000)
 * - Dropdowns: Dropdown menus (1001)
 * - Nested: Dialogs/Sheets opened from within sheets (1199-1200)
 * - Toasts: Toast notifications (1300)
 */
export const Z_INDEX = {
    /** Base overlay for sheets and dialogs */
    BASE_OVERLAY: 999,
    /** Base content for sheets and dialogs */
    BASE_CONTENT: 1000,
    /** Dropdown menus */
    DROPDOWN: 1001,
    /** Nested dialog overlay (opened from within sheets) */
    NESTED_OVERLAY: 1199,
    /** Nested dialog content (opened from within sheets) */
    NESTED_CONTENT: 1200,
    /** Toast notifications */
    TOAST: 1300,
} as const;

export type ZIndexLayer = (typeof Z_INDEX)[keyof typeof Z_INDEX];
